(function () {
    /**
     * StubFig module.
     * @module orb/stubFig
     */
    'use strict';

    var fig = function (param) {
        return param ? fig.figData()[param] : fig.figData();
    };

    fig.init = function(country) {
        var analyticsProvider = getAnalyticsProvider(country),
            isUK = countryMatches(["GB", "IM", "JE", "GG"], country);   

        fig.figData = function(){      
            return {
                /* ad flag set 1 (true) as this is required for bbcdotcom module to load analytics.
                   this will be overridden by dotcom if fig('uk') returns true, so we are not showing ads to UK users
                   https://github.com/bbc/bbcdotcom/blob/bebc48e0eaedf75ac8f0bba5455fa7c896946e89/webapp/php/sharedmodules/bbcdotcom/views/index/webservice/head.twig#L104 */
                ad: 1,
                ap: analyticsProvider,
                uk: isUK ? 1 : 0
            }
        };
    }

    fig.geo = {
        isUK: function () {
            return fig("uk");
        }
    }

    fig.isCached = function() { return false; }
    fig.isOverridden = function() { return false; }
    fig.isDefault = function() { return false; }

    function getAnalyticsProvider(country) {
        var providerCodes = [4, 8, 16],
            currencyProviders = [          
            ["US", "AS", "GU", "MP", "PR", "UM", "VI"],
            ["NZ"],
            ["AU"]
        ];
        var i = 0,
            max = currencyProviders.length;
        for (; i < max; i++) {
            if (countryMatches(currencyProviders[i], country)) {
                return providerCodes[i];
            }
        }
        return 0;
    }

    function countryMatches(validCountries, country) {
        return validCountries.indexOf(country.toUpperCase()) !== -1;
    }

    if(window && window.orb){
        window.orb.fig = fig;
    }

    if (typeof define === 'function' && define.amd) {
        define('orb/stubFig', function() {
            return fig;
        });
    }
})();